import { client } from '../client';
import { IGMConversationMedia } from './types/IGMConversationMedia';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface ConversationMessageMedia {
  url: string | URL;
}

export const getMedia = async (
  media_id: string,
  conversation_sid: string,
  userRole?: string,
): Promise<IGMConversationMedia> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(`${prefix}/conversations/${conversation_sid}/media/${media_id}`);
  return data;
};
